import { makeStyles, Theme } from "@material-ui/core/styles";

export const HighlightsStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: 16,
    "& .MuiOutlinedInput-root:active, .MuiOutlinedInput-root:focus, .MuiOutlinedInput-root:hover, .MuiOutlinedInput-root:visited":
      {
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "#0F172A",
          border: "1px solid #242424",
          boxShadow: "inset 0px -4px 0px #0F172A",
          borderRadius: "2px",
        },
      },
    "& .MuiButton-contained.Mui-disabled": {
      border: "1px solid rgba(0, 0, 0, 0.12)",
    },
    "& .MuiFormControl-root label": {
      color: "#0F172A",
      fontFamily: "Inter",
      fontSize: theme.typography.pxToRem(14),
      fontWeight: 700,
    },
    "& .MuiFormControl-root label span": {
      color: "#747F9D",
      fontFamily: "Lato",
      fontSize: theme.typography.pxToRem(14),
      fontWeight: 400,
    },
  },
  paper: {
    boxShadow: "0px 0px 25px rgba(0, 0, 0, 0.1)",
  },
  title: {
    display: "flex",
    marginBlockEnd: 16,
    "& .MuiTypography-root": {
      fontFamily: "Lato",
      fontSize: theme.typography.pxToRem(20),
      color: "#0F172A",
    },
  },
  icon: {
    "& path": {
      fill: "#000",
    },
  },
  button: {
    margin: "20px 0",
  },
  helperText: {
    textAlign: "right",
    fontFamily: "Roboto",
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(14),
    color: "#828282",
  },
}));
